import React from "react";
import _ from "underscore";
import { bindActionCreators } from "redux";
import { Link } from "react-router-dom";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import classNames from "classnames";
import {
  formatAssayApplicationType,
  formatStatus,
  formatDateTime,
  formatAssayFormat,
  formatUniversalAssayName,
  formatFluorophores,
  mapAppType,
} from "../../util/format.js";

export const ResultTableRow = (props) => {
  const { row, actions, classes, evenOddClass } = props;
  const [notmyAssay, toggleNotMyAssay] = React.useState(true);
  const AddToMyAssayButton = () =>
    notmyAssay === true ? (
      <button
        className={classNames("add-to-assays", "rounded", "solid", "small")}
        onClick={() => {
          toggleNotMyAssay(false);
          actions.addToMyAssay(row.id);
        }}
      >
        Add to My Assays
      </button>
    ) : (
      <a href="/digital-assays/assay-design-history">Go to Assays</a>
    );

  return (
    <React.Fragment>
      <TableRow className={classNames(classes.row, evenOddClass, "extended")}>
        {/* Assay Name */}
        <TableCell scope="row" padding="none">
          {
            <div>
              <Link to={`/digital-assays/assay-detail/${row.id}`}>
                <strong>{row && (row.assayName || row.id)}</strong>
              </Link>
            </div>
          }
        </TableCell>

        {/* Target Name for the assay*/}
        <TableCell padding="none">
          <div className="text-truncate" style={{ maxWidth: 80 }}>
            {row && row.targetName}
          </div>
        </TableCell>

        {/* Application Type for the assay */}
        <TableCell padding="none">
          {row && row.assayType && formatAssayFormat(row.assayType)}
        </TableCell>

        {/* Wet Lab validation status for the assay */}
        <TableCell padding="none">
          <div>{row && row.wetlabValidated}</div>
        </TableCell>

        {/* Chemistry for the assay */}
        <TableCell padding="none">
          <div>{row && row.chemistry}</div>
        </TableCell>

        {/* Dyes involved to design assay*/}
        <TableCell padding="none">
          <div className="text-truncate " style={{ maxWidth: 70 }}>
            {(row &&
              row.status &&
              row.status.toLowerCase() === "done" &&
              row.dyes &&
              formatFluorophores(row.dyes.join("/").toUpperCase())) ||
              "N/A"}
          </div>
        </TableCell>

        {/* Assay ID for the assay */}
        <TableCell padding="none">
          <div>{row && row.id}</div>
        </TableCell>
        {/* Gene ID for the given assay */}
        <TableCell padding="none">
          <div>{row && row.geneId}</div>
        </TableCell>
        {/* Gene Name for the given assay */}
        <TableCell padding="none">
          <div>{row && row.geneName}</div>
        </TableCell>

        {/* Cosmic ID for the given assay */}
        <TableCell padding="none">
          <div>{row && row.cosmicId}</div>
        </TableCell>

        {/* Buttons cell for the assay row */}
        <TableCell padding="none">
          <div className="text-center" style={{ minWidth: 135 }}>
            <AddToMyAssayButton />
          </div>
        </TableCell>
      </TableRow>
      <TableRow className={classNames(classes.row, evenOddClass)}>
        <TableCell colSpan="11">
          <div className="text-left">
            <h6>Gene Alias</h6>
            <div>
              {row && row.geneNameAlias && row.geneNameAlias.join(", ")}
            </div>
          </div>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
};
